var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"shell"}},[_c('div',{staticClass:"bar",style:({ width: _vm.scale + '%' })},[(_vm.scale > 0)?_c('label',[_vm._v(_vm._s(_vm.scale)+"%")]):_c('span',{staticClass:"blank"},[_vm._v("0%")])])])}
var staticRenderFns = []

export { render, staticRenderFns }